import React from "react";
import './styles/styles.css'
import Button from '@material-ui/core/Button'

interface Props {
   base64:any;
    handleSuccess:(base64: string)=>void;
    postSelectionButtonText: string;
    closeModal:()=>void

}

const Preview =  ({closeModal, base64, handleSuccess, postSelectionButtonText}: Props) =>{
    return (
        <div className="viewer">
            <img src={base64} alt={"Preview"}/>
            <Button
                onClick={()=>{
                    handleSuccess(base64)
                    closeModal()

                }}
                variant="contained"
                color="secondary"
            >
                {postSelectionButtonText}
            </Button>
        </div>
    )
}

export default Preview;